import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  getModulesBySet,
  getModuleDisplayData,
} from '../ModuleProgress/helpers';
import { selectIsAdminOfCurrentCourse } from '../Courses/selectors';

const defaultModuleSetName = 'Learning Activities';

const progressPageSelector = (state) => state.ProgressPage;

export const progressPageDataHasLoaded = createSelector(
  progressPageSelector,
  (progressPageData) => progressPageData.get('hasLoaded', false)
);

const progressPageModuleListSelector = createSelector(
  [progressPageSelector],
  (progressPageData) => progressPageData.get('moduleList', Immutable.List())
);

const progressPageModulesBySetSelector = createSelector(
  [progressPageModuleListSelector],
  (moduleList) => getModulesBySet(moduleList, defaultModuleSetName)
);

const progressPageCohortScheduleSelector = createSelector(
  progressPageSelector,
  (progressPageData) => progressPageData.get('cohortSchedule', Immutable.Map())
);

const cohortScheduleSelector = createSelector(
  progressPageCohortScheduleSelector,
  (cohortSchedule) => cohortSchedule.get('schedule', Immutable.Map())
);

const moduleStartDatesSelector = createSelector(
  progressPageCohortScheduleSelector,
  (cohortSchedule) => {
    let moduleStartDates = Immutable.Map();

    cohortSchedule.get('moduleStartdates', Immutable.List()).forEach((ms) => {
      ms.forEach((startDate, moduleId) => {
        moduleStartDates = moduleStartDates.set(moduleId, startDate);
      });
    });

    return moduleStartDates;
  }
);

const schedulingListByPagePathSelector = createSelector(
  progressPageCohortScheduleSelector,
  (cohortSchedule) => {
    let schedulingList = Immutable.Map();

    cohortSchedule
      .get('schedulingList', Immutable.List())
      .forEach((schedule) => {
        schedulingList = schedulingList.set(schedule.get('pagePath'), schedule);
      });

    return schedulingList;
  }
);

export const progressPageModuleSetsSelector = createSelector(
  [
    progressPageModuleListSelector,
    progressPageModulesBySetSelector,
    cohortScheduleSelector,
    moduleStartDatesSelector,
    schedulingListByPagePathSelector,
    selectIsAdminOfCurrentCourse,
  ],
  (
    moduleList,
    modulesBySet,
    schedule,
    moduleStartDates,
    schedulingList,
    isCourseAdmin
  ) => {
    return modulesBySet.map((modulesInSet) =>
      Immutable.fromJS(
        getModuleDisplayData(
          moduleList.toJS(),
          modulesInSet.toJS(),
          schedule.toJS(),
          moduleStartDates,
          schedulingList,
          isCourseAdmin,
          true
        )
      )
    );
  }
);

export const progressPageModuleSetsOrderSelector = createSelector(
  [progressPageModuleListSelector],
  (moduleList) => {
    let moduleSetNames = Immutable.OrderedSet();

    moduleSetNames = moduleSetNames.add(defaultModuleSetName);

    moduleList.forEach((module) => {
      const setName = module.get('setName') || null;
      if (setName) {
        moduleSetNames = moduleSetNames.add(setName);
      }
    });

    return moduleSetNames.toList();
  }
);
